import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const Header = (props) => {
  const { t, cycleName, subjectName } = props;

  return (
    <>
      <div className="form__form-group card__title">
        <span className="form__form-group-label bold-text mr-2">
          {t('general.cycle-closing-two-points')}
        </span>
        <span className="form__form-group-label bold-text mr-1">
          {cycleName}
        </span>
        <span className="form__form-group-label bold-text mr-1">
          {t('general.of-the-discipline').toLowerCase()}
        </span>
        <span className="form__form-group-label bold-text">{subjectName}</span>
      </div>
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  cycleName: PropTypes.string.isRequired,
  subjectName: PropTypes.string.isRequired,
};

export default withTranslation('common')(Header);
